import { Injectable } from '@angular/core';
import type { JssState, JssStateUpdate } from '@core/jss-routing';
import { getRouteJssState, JssStateActionTypes } from '@core/jss-routing';
import type { OnInitEffects } from '@ngrx/effects';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import type { Action } from '@ngrx/store';
import { select, Store } from '@ngrx/store';
import { filter, first, map, mergeMap } from 'rxjs/operators';

import { getBlogDetailPageTemplateId } from './blog.selector';
import {
  KnowledgeBaseInitAction,
  KnowledgeBaseRouteChange,
  KnowledgeBaseTypes,
} from './knowledge-base.actions';

@Injectable()
export class KnowledgeBaseEffects implements OnInitEffects {
  templateIdSelector$ = this.store$.pipe(select(getBlogDetailPageTemplateId));

  initialLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType<KnowledgeBaseInitAction>(KnowledgeBaseTypes.INIT),
      mergeMap(() =>
        this.store$.pipe(
          select(getRouteJssState),
          filter((state): state is JssState => state != null)
        )
      ),
      map((state) => new KnowledgeBaseRouteChange(state)),
      first()
    )
  );

  onNewRoute$ = createEffect(() =>
    this.actions$.pipe(
      ofType<JssStateUpdate>(JssStateActionTypes.UPDATE),
      map((action) => new KnowledgeBaseRouteChange(action.payload))
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly store$: Store<any>
  ) {}

  // Triggered for first page load when lazily loaded
  ngrxOnInitEffects(): Action {
    return new KnowledgeBaseInitAction();
  }
}
